import { render, staticRenderFns } from "./educationTab.vue?vue&type=template&id=1a1b37c4&"
import script from "./educationTab.vue?vue&type=script&lang=js&"
export * from "./educationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports